import React from 'react';
import Dropdown from "../Dropdown";
import Status from "../../pages/parcels/form_v3/status";

const StateDropdown = ({compact, options, value, onChange, placeholder}) => {

    const renderLabel = (label) => {
        return {
            content: <Status code={label.code}/>
        }
    }

    return (
        <Dropdown
            name={'states'}
            placeholder={placeholder}
            value={value}
            search={false}
            className='state-dropdown'
            compact={compact}
            multiple
            options={options}
            renderLabel={renderLabel}
            onChange={onChange}
        />
    );
};

export default StateDropdown;


// WEBPACK FOOTER //
// ./App/components/Dropdowns/StateDropdown.jsx